import { parametersServices } from "../../../services";

export async function CompanyTypes() {
	const companyTypes = await parametersServices.getCompanyTypes();

	const columns = [
		{
			key: "id",
			name: "#",
			sort: 0,
			type: "id",
		},
		{
			key: "value",
			name: "static-parameters.title",
			sort: 1,
			type: "title",
		},
		{
			key: "key",
			name: "static-parameters.key",
			sort: 2,
			type: "title",
		},
	];
	const rows = [];

	await companyTypes.payload?.map((companyType, key) => {
		rows.push({
			id: key + 1,
			value: companyType.value,
			key: companyType.key,
		});
	});
	const tableData = {
		columns: columns,
		rows: rows,
	};
	return tableData;
}
